import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalConfirm from '../../../commons/ModalConfirm';
import { BtnOutlineRed } from '../../../styled-components';

const DeleteClaimModal = ({ data: claim = {}, onConfirm, events = [] }) => {
  const [t] = useTranslation('CLAIMS');
  const [modal, setModal] = useState(false);

  const handleClaimDelete = async () => {
    await onConfirm(claim);
  };

  return (
    <>
      <ModalConfirm
        text={t('CLAIMS:CONFIRM_DELETE')}
        style={{ display: 'inline-block' }}
        onConfirm={handleClaimDelete}
      >
        <BtnOutlineRed type="button" className="uppercase">
          Elimina
        </BtnOutlineRed>
      </ModalConfirm>
    </>
  );
};

export default DeleteClaimModal;
